import { render, staticRenderFns } from "./GlueItem.vue?vue&type=template&id=597c58f3"
import script from "./GlueItem.vue?vue&type=script&lang=js"
export * from "./GlueItem.vue?vue&type=script&lang=js"
import style0 from "./GlueItem.vue?vue&type=style&index=0&id=597c58f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports